import AbstractModel from '../AbstractModel';

class EquipmentGroupModel extends AbstractModel {}

export default EquipmentGroupModel;
